// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo-index-logo-984df3d3","icon":"Logo-index-icon-3dd4140e"};